export default {
  'PAYMENTS.INVALID_TEMPLATE_NAME': 'Template name already used',

  'paymentTemplates.addendaInformation': 'Addenda Information',
  'paymentTemplates.bankIdNumberType': 'Bank ID Number Type',
  'paymentTemplates.bankIdNumber': 'Bank ID Number',
  'paymentTemplates.bankBranchCountryCode': 'Bank Branch Country Code',
  'paymentTemplates.destinationCountry': 'Destination Country',
  'paymentTemplates.foreignPaymentAmount': 'Foreign Payment Amount',
  'paymentTemplates.freeFormInformation': 'Freeform Information',
  'paymentTemplates.noPaymentsToApprove': 'No templates to approve',
  'paymentTemplates.receivingCompanyIndividual': 'Receiving Company/Individual',
  'paymentTemplates.receivingPartyInformation': 'Receiving Party Information',
  'paymentTemplates.originatingPartyInformation': 'Originating Party Information',
  'paymentTemplates.originatingBankDetails': 'Originating Bank Details',
  'paymentTemplates.originatingBankName': 'Originating Bank Name',
  'paymentTemplates.originatorName': 'Originator Name',
  'paymentTemplates.receivingName': 'Receiving Name',
  'paymentTemplates.requiresMyApproval': 'Requires My Approval',
  'paymentTemplates.receivingBankDetails': 'Receiving Bank Details',
  'paymentTemplates.receivingBankName': 'Receiving Bank Name',
  'paymentTemplates.stateProvince': 'State/Province',
  'paymentTemplates.postalCode': 'Postal Code',
  'paymentTemplates.charges.BEN': 'Beneficiary',
  'paymentTemplates.charges.OUR': 'Ours',
  'paymentTemplates.charges.SHA': 'Share',
  'paymentTemplates.header.initiate': 'Initiate (<%= count %>) payments',

  'paymentTemplates.error': '<%=count %> Template(s) cannot be approved',
  'paymentTemplates.actionError': '<%=count %> Template(s) cannot be <%= action %>',
  'paymentTemplates.noDataMessage': 'No payment templates found.',

  'paymentTemplates.validation.descriptiveDate': 'Six characters are accepted.',
  'paymentTemplates.validation.loanAccountType': 'Loan accounts not valid for Debits.',
  'paymentTemplates.validaton.selecton.fx': 'FX not allowed in quick entry',
  'paymentTemplates.validaton.amount.notZero': 'Transaction amount cannot be zero.',
  'paymentTemplates.validaton.amount.exceedsCustomerLimit':
    "Transfer amount exceeds the customer's transaction limit",
  'paymentTemplates.validaton.amount.exceedsUserLimit':
    "Transfer amount exceeds the user's transaction limit",
  'paymentTemplates.bulkWireInit.noTemplates':
    'There are no more templates available to initiate a payment.',
  'paymentTemplates.bulkWireInit.confirmation': `You are about to submit <%=length %> payments for a total of <%=amount%>`,
  'paymentTemplates.bulkWireInit.continuing': `Continuing...`,
  // ACH payment action messages
  'paymentTemplates.payment.success.modified': 'Payment has been modified',

  // ACH template action messages
  'paymentTemplates.success.send': 'Success! Payment has been initiated.',
  'paymentTemplates.success.sendInitiate': 'Success! Payment has been initiated',
  'paymentTemplates.success.copyaspayment': 'Success! Payment has been copied',
  'paymentTemplates.success.copyastemplate': 'Success! Payment has been copied as a template',
  'paymentTemplates.success.initiate': 'Success! Payment has been initiated',
  'paymentTemplates.success.approve': 'Success! <%=count %> template(s) approved',
  'paymentTemplates.success.modified': 'Template has been modified',
  'paymentTemplates.success.delete': 'Success! <%=count %> template(s) deleted',
  'paymentTemplates.success.disable': 'Success! <%=count %> template(s) disabled',
  'paymentTemplates.success.enable': 'Success! <%=count %> template(s) enabled',
  'paymentTemplates.success.reject': 'Success! <%=count %> template(s) rejected',

  // Wire template action messages
  'wireTemplates.success.create': 'Template created',
  'wireTemplates.success.send': 'Success! Payment has been activated',
  'wireTemplates.success.copyaspayment': 'Success! Payment has been copied',
  'wireTemplates.success.copyastemplate': 'Success! Payment has been copied as a template',
  'wireTemplates.success.initiate': 'Success! Payment has been initiated',
  'wireTemplates.success.enable': '<%=count %> template(s) enabled',
  'wireTemplates.success.approve': '<%=count %> template(s) approved',
  'wireTemplates.success.modified': 'Template modified',
  'wireTemplates.success.delete': '<%=count %> template(s) deleted',
  'wireTemplates.success.disable': '<%=count %> template(s) disabled',
  'wireTemplates.success.reject': '<%=count %> template(s) rejected',

  'wireTemplate.success.delete': 'Template Deleted',
  'wireTemplate.success.reject': 'Template Rejected',

  'paymentTemplates.success.createrecurring': 'Success! Recurring instruction created.',
  'paymentTemplates.success.updaterecurring': 'Success! Recurring instruction updated.',
  'paymentTemplates.success.removerecurring': 'Success! Recurring instruction removed.',

  'paymentTemplates.notPermittedBulk.approve':
    'You are not eligible to approve some selected template(s).',
  'paymentTemplates.notPermittedBulk.enable':
    'You are not eligible to enable some selected template(s).',
  'paymentTemplates.notPermittedBulk.delete':
    'You are not eligible to delete some selected template(s).',
  'paymentTemplates.notPermittedBulk.disable':
    'You are not eligible to disable some selected template(s).',
  'paymentTemplates.notPermittedBulk.reject':
    'You are not eligible to reject some selected template(s).',
  'paymentTemplates.notPermittedBulk.initiate':
    'Some selected template(s) are not eligible for payment initiation.',
  'paymentTemplates.notPermittedBulk.initiate.differentCategory':
    'Please select only one payment category type for bulk initiation.',
  'paymentTemplates.warnMessage.approve': 'You are about to approve the following template(s).',
  'paymentTemplates.warnMessage.delete': 'You are about to delete the following template(s).',
  'paymentTemplates.warnMessage.disable': 'You are about to disable the following template(s).',
  'paymentTemplates.warnMessage.reject': 'You are about to reject the following template(s).',

  'paymentTemplates.pageTitle.all.approve': 'Approve Template(s)',
  'paymentTemplates.pageTitle.all.delete': 'Delete Template(s)',
  'paymentTemplates.pageTitle.all.disable': 'Disable Template(s)',
  'paymentTemplates.pageTitle.all.initiate': 'Initiate Template(s)',
  'paymentTemplates.pageTitle.all.reject': 'Reject Template(s)',

  'paymentTemplates.pageTitle.ach.initiate': 'Initiate Multiple ACH',
  'paymentTemplates.pageTitle.ach.approve': 'Approve ACH Template(s)',
  'paymentTemplates.pageTitle.ach.delete': 'Delete ACH Template(s)',
  'paymentTemplates.pageTitle.ach.disable': 'Disable ACH Template(s)',
  'paymentTemplates.pageTitle.ach.reject': 'Reject ACH Template(s)',

  'paymentTemplates.pageTitle.wire.approve': 'Approve Wire Template(s)',
  'paymentTemplates.pageTitle.wire.delete': 'Delete Wire Template(s)',
  'paymentTemplates.pageTitle.wire.disable': 'Disable Wire Template(s)',
  'paymentTemplates.pageTitle.wire.reject': 'Reject Wire Template(s)',

  'paymentTemplates.pageTitle.loan.approve': 'Approve Loan Payment Template(s)',
  'paymentTemplates.pageTitle.loan.delete': 'Delete Loan Payment Template(s)',
  'paymentTemplates.pageTitle.loan.disable': 'Disable Loan Payment Template(s)',
  'paymentTemplates.pageTitle.loan.reject': 'Reject Loan Payment Template(s)',

  'paymentTemplates.modalTitle.delete': 'Delete Payment Template',
  'paymentTemplates.modalTitle.deletetransactions': 'Delete Transaction',
  'paymentTemplates.modalTitle.disable': 'Disable Payment Template',
  'paymentTemplates.modalTitle.import.accept': 'Accept File For Final Processing',
  'paymentTemplates.modalTitle.import.batchaccept': 'Accept Import  For  Processing',

  'paymentTemplates.modalTitle.import.delete': 'Delete Import File',
  'paymentTemplates.modalTitle.import.batchdelete': 'Delete Import Batch',

  'paymentTemplates.modalTitle.removerecurring': 'Delete Recurring Instruction',

  'paymentTemplates.modalBody.delete':
    'template(s) will be deleted and will be permanently removed.',
  'paymentTemplates.modalBody.deletetransactions':
    'Transaction will be deleted and will be permanently removed.',
  'paymentTemplates.modalBody.disable': 'template(s) will be disabled.',
  'paymentTemplates.modalBody.proceed': 'Do you want to proceed?',
  'paymentTemplates.modalBody.removerecurring':
    'The instruction will be deleted and all scheduled payments will be canceled.',
  'paymentTemplates.modalBody.unsavedChanges':
    'You have unsaved changes. Initiate a payment anyways?',

  'paymentTemplates.modalBody.nachaSubTitle':
    'This will create a new <%=paymentType %>  template named  <%=templateName %> with <%=totalCredits %> credits and <%=totalDebits %> debits. Template approval requirements may apply.',
  'paymentTemplates.modalBody.nachaSubTitleCustom':
    'This will create a new <%=paymentType %>  template with <%=totalCredits %> credits and <%=totalDebits %> debits. Template approval requirements may apply.',
  'payments.modalBody.nachaSubTitle':
    'This will create a new <%=paymentType %> payment named <%=templateName %> with <%=totalCredits %> credits and <%=totalDebits %> debits for a total of <%=paymentTotal %> on <%=paymentDate %>',
  'payments.modalBody.nachaSubTitleCustom':
    'This will create a new <%=paymentType %> payment named with <%=totalCredits %> credits and <%=totalDebits %> debits for a total of <%=paymentTotal %>',
  'paymentTemplates.modalBody.userCustomSubTitle':
    'This will update <%=paymentType %>  template named <%=templateName %> with the transactions from the file. Template approval requirements may apply.',
  'payments.modalBody.userCustomSubTitle':
    'This will update <%=paymentType %>  payment named <%=templateName %> with the transactions from the file.',

  // Columns
  'paymentTemplates.achSenderID': 'ACH Sender ID',
  'paymentTemplates.achListViewName': 'ACH Templates',
  'paymentTemplates.achSender': 'ACH Sender',
  'paymentTemplates.addendum': 'Addenda',
  'paymentTemplates.allListViewName': 'Show All',
  'paymentTemplates.allTemplates': 'All Templates',
  'paymentTemplates.amount': 'Amount',
  'paymentTemplates.batchDescription': 'Batch Description',
  'paymentTemplates.beneficiary': 'Beneficiary',
  'paymentTemplates.beneficiaryAccountNumber': 'Beneficiary Account',
  'paymentTemplates.beneficiaryAccountType': 'Account Type',
  'paymentTemplates.beneficiaryAddressLine1': 'Payee Address Line 1',
  'paymentTemplates.beneficiaryAddressLine2': 'Payee Address Line 2',
  'paymentTemplates.beneficiaryAddressLine3': 'Payee Address Line 3',
  'paymentTemplates.beneficiaryBank': 'Beneficiary Bank',
  'paymentTemplates.beneficiaryBankAba': 'Bank Code / Number',
  'paymentTemplates.beneficiaryBankRoutingNumber': 'Bank Code',
  'paymentTemplates.companyName': 'ACH Company Name',
  'paymentTemplates.currency': 'Currency',
  'paymentTemplates.destinationCurrency': 'Destination Currency',
  'paymentTemplates.discretionaryData': 'Company Discretionary Data',
  'paymentTemplates.financialInstitutionGateway': 'Financial Institution/Gateway',
  'paymentTemplates.frequency': 'Frequency',
  'paymentTemplates.fromAccount': 'From Account',
  'paymentTemplates.fxIndicator': 'FX Indicator',
  'paymentTemplates.intermediaryBank1': 'Intermediary Bank 1',
  'paymentTemplates.intermediaryBank2': 'Intermediary Bank 2',
  'paymentTemplates.internationalACHDetails': 'International ACH Details',
  'paymentTemplates.nextDate': 'Next Payment',
  'paymentTemplates.numItems': 'Total Count',
  'paymentTemplates.originatingBankAccountName': 'From Account Name',
  'paymentTemplates.originatingCurrency': 'Originating Currency',
  'paymentTemplates.payeeName': 'Payee Name',
  'paymentTemplates.paymentCategory': 'Payment Category',
  'paymentTemplates.paymentEntryDescription': 'Company Entry Description',
  'paymentTemplates.labelText': 'Payment Templates',
  'paymentTemplates.paymentType': 'Payment Type',
  'paymentTemplates.possibleActions': 'Actions',
  'paymentTemplates.receiverName': 'Receiver Name',
  'paymentTemplates.schedule': 'Frequency',
  'paymentTemplates.status': 'Status',
  'paymentTemplates.templateName': 'Template Name',
  'paymentTemplates.totalCredits': 'Total Credits',
  'paymentTemplates.totalDebits': 'Total Debits',
  'paymentTemplates.transactionDate': 'Effective Entry Date',
  'paymentTemplates.wireListViewName': 'Wire Templates',
  'paymentTemplates.rmaListViewName': 'Requires My Approval',
  'paymentTemplates.loanTemplates': 'Loan Templates',
  'paymentTemplates.linkGroups.ach': 'ACH',
  'paymentTemplates.linkGroups.wire': 'Wire',
  'paymentTemplates.templateHasBeenSubmitted': 'Template has been submitted for approval',
  'paymentTemplates.templateHasBeenCreated': 'Template has been created',
  'paymentTemplates.actionTitle.initiateAchPayment': 'Initiate ACH Payment',
  'paymentTemplates.actionTitle.initiateAchCollection': 'Initiate ACH Collection',
  'paymentTemplates.less': 'less',
  'paymentTemplates.more': 'more',
  'paymentTemplates.removeBtn': 'remove button',

  // Custom import review
  'customImport.title': 'Accept Import',
  'customImport.titleDelete': 'Discard Uploaded Transactions',

  'paymentTemplates.receiver': 'Receiver',
  'paymentTemplates.multiple': 'Multiple',

  // Payment template status
  'paymentTemplates.status.AVAILABLE_FOR_USE': 'Available for use',
  'paymentTemplates.status.DISABLED': 'Disabled',
  'paymentTemplates.status.REJECTED_BY_APPROVER': 'Rejected by approver',
  'paymentTemplates.status.REQUIRES_MY_APPROVAL': 'Requires my approval',
  'paymentTemplates.status.REQUIRES_OTHERS_APPROVAL': 'Requires others approval',

  'paymentTemplates.views.containsACH': 'Contains ACH',
  'paymentTemplates.views.containsLoans': 'Contains Loan',
  'paymentTemplates.views.containsWire': 'Contains Wire',
  'paymentTemplates.views.containsRequiresMyApproval': 'Contains Requires My Approval',

  'paymentTemplates.isoAddress.warning':
    'System requires the beneficiary address to be re-entered for templates noted in the list.  You may remove these templates to proceed or cancel and update the beneficiary address in the template.',
  'paymentTemplates.isoAddress.templateStatus': 'Requires address to be re-entered',
  'paymentTemplates.serviceMessage.title.domestic': 'Domestic Wire Service Message',
  'paymentTemplates.serviceMessage.title.international': 'International Wire Service Message'
};
